import './App.css';
import Navbar from './Components/Navbar';
import PageNotFound from './Components/PageNotFound';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Home from './Pages/Home';
import News from './Pages/News';
import FAQ from './Pages/FAQ';
import { Route, Routes } from 'react-router-dom';
import Footer from './Components/Footer';
import Login from './Pages/Login';

//export const first = useContext(second)

function App() {
  //const [state, dispatch] = useReducer(first, second, third)
   
  
  return (
    <div className="App">
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home/>} />
          <Route path="News" element={<News/>} />
          <Route path="About" element={<About />} />
          <Route path="Contact" element={<Contact/>} />
          <Route path="FAQ" element={<FAQ/>} />
        <Route path="*" element={<PageNotFound/>} />
        <Route path="/login" element={<Login/>}/>
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
